import { scrollPageTo } from './utils';

export default function blockExpandable(blocks) {
  blocks.forEach((block) => {
    const trigger = block.querySelector('.block-expandable__trigger');
    const eBody = block.querySelector('.block-expandable__body');
    let collapseHeight = 0;

    if (!eBody) return;

    function getCollapsedHeight() {
      collapseHeight = eBody.clientHeight;

      if (block.classList.contains('expanded')) {
        const cloneBody = eBody.cloneNode(true);
        cloneBody.style.visibility = 'hidden';
        cloneBody.style.position = 'fixed';
        cloneBody.style.right = '100%';
        cloneBody.style.bottom = '100%';
        block.after(cloneBody);
        collapseHeight = cloneBody.clientHeight;
        cloneBody.remove();
      }
      if (collapseHeight < eBody.scrollHeight) {
        block.classList.add('block-expandable--truncated');
      } else {
        block.classList.remove('block-expandable--truncated');
      }
    }

    getCollapsedHeight();
    window.addEventListener('resize', getCollapsedHeight);

    trigger.addEventListener('click', (evt) => {
      evt.preventDefault();
      if (block.classList.contains('expanded')) {
        const triggerRect = trigger.getBoundingClientRect();
        const bodyRect = eBody.getBoundingClientRect();
        const bodyHeight = bodyRect.height;

        if (bodyRect.top < triggerRect.top) {
          // window.scrollTo(0, document.documentElement.scrollTop - (bodyHeight - collapseHeight));
          scrollPageTo(document.documentElement.scrollTop - (bodyHeight - collapseHeight), 300);
        }

        eBody.style.maxHeight = `${eBody.scrollHeight}px`;
        setTimeout(() => {
          eBody.style.maxHeight = `${collapseHeight}px`;
        }, 0);
        eBody.addEventListener(
          'transitionend',
          () => {
            eBody.style.maxHeight = null;
            block.classList.remove('expanded');
          },
          { once: true },
        );
      } else {
        eBody.style.maxHeight = `${eBody.scrollHeight}px`;
        block.classList.add('expanded');
        eBody.addEventListener(
          'transitionend',
          () => {
            eBody.style.maxHeight = null;
          },
          { once: true },
        );
      }
    });
  });
}
